export const COLOR ={
    LIGHT_YELLOW:"#EDCF80",
    WHITE:"#FFFFFF",
    BLACK:"#000000",
    GRAY:"#C4C4C4",
    BLUE:"#0B214D",
    RED:"#EC2939"
}